// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedSindaFund: null,
  addSindaFundRate: null,
  updateSindaFundRate: null
}

const sindas = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_SINDA_FUNDS_DROPDOWN':
      return { 
        ...state, 
        dropdown: action.data
      }
    case 'GET_ALL_SINDA_FUNDS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_SINDA_FUNDS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_SINDA_FUND':
      return { ...state, selectedSindaFund: action.selectedSindaFund }
    case 'ADD_SINDA_FUND':
      return { ...state }
      case 'DELETE_SINDA_FUND':
        return { ...state }

        // SindaFund Rates
        case 'ADD_SINDA_FUND_RATE':
          return { ...state, addSindaFundRate: action.data }
        case 'UPDATE_SINDA_FUND_RATE':
          return { ...state, updateSindaFundRate: action.data }

    default:
      return { ...state }
  }
}
export default sindas
